var map = {
	"./icon-question-rating-skin-heart.svg": "203d",
	"./icon-question-rating-skin-like.svg": "267c",
	"./icon-question-rating-skin-radio_button.svg": "fdd5",
	"./icon-question-rating-skin-smile.svg": "7068",
	"./icon-question-rating-skin-star.svg": "d9fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a6c7";